import React from 'react';
import { MobileStockLocationSession } from '../types/mobile_stock_location';

export interface MobileStockLocationSessionContextProps {
  sessions: Map<string, MobileStockLocationSession>;
  sessionsByStockLocationId: Map<string, MobileStockLocationSession[]>;
  sessionsLoading: boolean;
}

const defaultContext: MobileStockLocationSessionContextProps = {
  sessions: new Map(),
  sessionsByStockLocationId: new Map(),
  sessionsLoading: false,
};

export const MobileStockLocationSessionContext =
  React.createContext<MobileStockLocationSessionContextProps>(defaultContext);
